import createDetailsSelector from './createDetailsSelector';
import { getInputData } from '../getInputData';
import { getInputAlarmRanges } from '../getInputAlarmRanges';
import { getInputSensors } from '../getInputSensors';

export default createDetailsSelector(getInputData, getInputAlarmRanges, getInputSensors);